<div class="h-full flex items-center justify-center">
	<p-stepper [(value)]="activeStep" class="basis-[40rem]">
		<p-step-list>
			@for(step of steps; track step.key) {
			<p-step [value]="step.key" class="flex flex-row flex-auto gap-2">
				<ng-template #content let-activateCallback="activateCallback" let-value="value">
					<button class="bg-transparent border-0 inline-flex flex-col gap-2 cursor-pointer" (click)="activateCallback()">
						<span
							class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center text-slate-400"
							[ngClass]="{
								'bg-slate-200 border-slate-200': value <= activeStep,
								'border-slate-200': value > activeStep
							}">
							<fa-icon [icon]="step.icon"></fa-icon>
						</span>
					</button>
				</ng-template>
			</p-step>
			}
			<!--
			<p-step [value]="2" class="flex flex-row flex-auto gap-2">
				<ng-template
					#content
					let-activateCallback="activateCallback"
					let-value="value"
				>
					<button
						class="bg-transparent border-0 inline-flex flex-col gap-2"
						(click)="activateCallback()"
					>
						<span
							class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center text-slate-400"
							[ngClass]="{
								'bg-slate-200 border-slate-200':
									value <= activeStep,
								'border-slate-200': value > activeStep
							}"
						>
							<fa-icon [icon]="['fas', 'sitemap']"></fa-icon>
						</span>
					</button>
				</ng-template>
			</p-step>

			<p-step [value]="3" class="flex flex-row flex-auto gap-2">
				<ng-template
					#content
					let-activateCallback="activateCallback"
					let-value="value"
				>
					<button
						class="bg-transparent border-0 inline-flex flex-col gap-2"
						(click)="activateCallback()"
					>
						<span
							class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center text-slate-400"
							[ngClass]="{
								'bg-slate-200 border-slate-200':
									value <= activeStep,
								'border-slate-200': value > activeStep
							}"
						>
							<fa-icon [icon]="['fas', 'star']"></fa-icon>
						</span>
					</button>
				</ng-template>
			</p-step> -->
		</p-step-list>

		<p-step-panels>
			<p-step-panel [value]="1">
				<ng-template #content let-activateCallback="activateCallback">
					<div class="flex flex-col gap-4 mx-auto items-center justify-center" style="min-height: 16rem; max-width: 40rem">
						<img src="./assets/img/aeocloud_logo.svg" class="h-20" alt="AeoCloud Logo" />
						<h2 class="text-2xl font-semibold">Welcome to AeoCloud</h2>
						<p class="text-slate-400 text-center mb-4 font-light">
							A cloud-native platform to manage SmartThings hubs and locations, automate rules, and generate powerful insights
							from sensor data — all in one sleek, connected experience.
						</p>
						<p>We're excited to have you on board. Before you get started, we'll guide you through a quick initial setup.</p>
						<p>In the next steps, you'll:</p>
						<ul class="list-disc">
							<li>create your organization to manage your team, properties and SmartThings hubs,</li>
						</ul>
						<p>This will only take a few minutes — and then you're ready to go!</p>
					</div>
					<div class="flex pt-6 justify-end">
						<p-button (onClick)="activateCallback(2)">
							<span>Next</span>
						</p-button>
					</div>
				</ng-template>
			</p-step-panel>

			<p-step-panel [value]="2">
				<ng-template #content let-activateCallback="activateCallback">
					<form [formGroup]="organizationForm">
						<div class="flex flex-col gap-4 mx-auto" style="min-height: 16rem; max-width: 20rem">
							<div class="text-center mt-4 mb-4 text-xl font-semibold">Setup your Organization</div>
							<div class="flex flex-col">
								<label for="name">Organization name</label>
								<input formControlName="name" pInputText id="input" type="text" placeholder="Name" fluid />
							</div>
							<div class="flex flex-col">
								<label for="description">Description</label>
								<textarea
									formControlName="description"
									pTextarea
									placeholder="Description"
									[attr.maxlength]="descriptionMax"></textarea>
								<span class="text-xs"
									>{{ organizationForm.get("description")?.value.length || 0 }}/{{ descriptionMax }}
								</span>
							</div>
						</div>
					</form>
					<div class="flex pt-6 justify-between">
						<p-button (onClick)="activateCallback(1)" severity="secondary">
							<span>Back</span>
						</p-button>
						<p-button (onClick)="activateCallback(3)">
							<span>Next</span>
						</p-button>
					</div>
				</ng-template>
			</p-step-panel>
			<p-step-panel [value]="3">
				<ng-template #content let-activateCallback="activateCallback">
					<div class="flex flex-col gap-2 mx-auto" style="min-height: 16rem; max-width: 24rem">
						<div class="text-center mt-4 mb-4 text-xl font-semibold">Setup finisched!</div>
						<div class="text-center">
							AeoCloud setup completed successfully. You can now connect, manage, and monitor all your device hubs from a
							single, unified platform.
						</div>
					</div>
					<div class="flex pt-6 justify-between">
						<p-button (onClick)="activateCallback(2)" severity="secondary">
							<span>Back</span>
						</p-button>
						<p-button (onClick)="finischSetup()" severity="secondary">
							<span>Finish</span>
						</p-button>
					</div>
				</ng-template>
			</p-step-panel>
		</p-step-panels>
	</p-stepper>
</div>
